import { globalConf } from './../Modelos/GlobalConf';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VariablesService } from './variables.service';
import { TokenALO } from '../Modelos/TokenALO';
import * as moment from 'moment';
import { EmpresasUsuario } from '../Modelos/empresas_usuario';

@Injectable({
  providedIn: 'root'
})
export class AmPresenciaService {
  private autorizacion: string;
  cerar: any;

  constructor(
    public http: HttpClient,
    public variables: VariablesService) { }

  getTokenUsuario(usuario: string, password: string): Observable<any> {


    let body = 'grant_type=password&username=' + usuario + '&password=' + password + '&scope=ALO'

    const cabecera = new HttpHeaders()
      .set('Content-Type', 'application/json')

    let res = this.http.post(globalConf.url_api_presencia + globalConf.path_Token, body, {
      headers: cabecera

    })
    return res;
  }

  usuarioLoginToken() {
    const parametros = new HttpParams()
      .set('filtroModulo', 'FITO')


    let res = this.http.get(globalConf.url_api_presencia + globalConf.path_Login_listadoEmpresas, {
      headers: {
        'Authorization': "Bearer " + this.variables.tokenLogin.access_token,
      }, params: parametros
    })
    return res;
  }

  confirmarResetearPassword(pwd: string, pwdrepetida: string, tokenEmpleado: string) {

    let body = {
      "Pwd": pwd,
      "ConfirmPwd": pwdrepetida,
      "GUID": tokenEmpleado,
      // "Id_Tercero": codigoEmpleado
    }

    let res = this.http.post(globalConf.url_api_presencia + globalConf.path_account_confirmReset, body, {})

    return res;

  }









  obtenerLoginMASListaEmpresas(usuario, pwd): Observable<any> {
    console.log('En el servicio login');
    let body;
    body = { usuario: usuario, pwd: pwd };
    const cabecera = new HttpHeaders()
      // .set( 'Authorization' , 'Basic cmVzdF9wcmVzZW5jaWFAYW1zeXN0ZW0uZXM6QU1TWVNURU0=')
      .set('Content-Type', 'application/json');
    // console.log("cabecera " + cabecera.get('Authorization'));
    console.log('cabecera ' + cabecera.get('Content-Type'));
    this.variables.autorizacionBase64 = btoa(usuario + ':' + pwd);

    return this.http.post(
      globalConf.url_api_presencia + globalConf.path_Login_listadoEmpresas,
      body,
      { headers: cabecera }
    );
  }

  resetPassword(email: string) {
    console.log('Reset de la contraseña ');
    const cabecera = new HttpHeaders().set('Content-Type', 'application/json');
    const parametros = new HttpParams().set('Email', email);
    const body = JSON.stringify(email);
    console.log('body  ' + body);
    console.log('body  JSON.stringify ' + JSON.stringify(body));
    console.log('body  JSON.stringify ' + JSON.stringify(email));
    return this.http.post(
      globalConf.url_api_presencia + globalConf.path_account_resetPassword,
      JSON.stringify(email),
      { headers: cabecera }
    );
  }

  confirmarRessetPassword() {
    console.log('Confirmar Reset de la contraseña ');
    const cabecera = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(
      globalConf.url_api_presencia + globalConf.path_account_confirmReset,
      { headers: cabecera }
    );
  }

  comprobarVersionApp() {
    const cabecera = new HttpHeaders().set('Content-Type', 'application/json');
    const parametros = new HttpParams().set('version', globalConf.app_version);

    const body = globalConf.app_version;
    console.log('comprobar version de la app      ------------' + globalConf.app_version);
    return this.http.get(
      globalConf.url_api_presencia + globalConf.path_administracion_version,
      { headers: cabecera, params: parametros }
    );
  }

  postDocumentosTransacciones(empresa: EmpresasUsuario, idDocumento:number, idTransaccion: number, resultado: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const data = [
      {
        "idDocumento": idDocumento,
        "idTransaccion": idTransaccion,
        "destino": "AICA",
        "resultado": resultado,
        "fechaTransaccion": moment().format()
      }
    ];

    return this.http.post(globalConf.url_api_presencia + globalConf.path_v2_documentosTransacciones + empresa.GUID_Empresa, data, { headers: headers })
  }

}


